import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';

import { getLabel } from "../../tools/Dictionary";
import { isValidEmail } from "../../tools/GeneralHelper";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import LoadingComponent from "../Commons/LoadingComponent";

import authApi from "../../api/authApi";

import { getLanguages } from "../../slices/languageSlice";

import logo from "../../images/Innovair_logo.png";

const AuthSignup = (props) =>
{
  //Redux
  const Language = useSelector(getLanguages).filter(lang => lang.code != "ES"); // Exclude Spanish language

  //Navigation
  const Navigate = useNavigate();

  //Variables
  const component = "AuthSignup";

/*
    email: "geo_hound@hotmail.com",
    password: "test123!",
    passwordRepeat: "test123!",
    firstName: "Jimmy",
    lastName: "Perreault",
    companyName: "Omegabyte",
    language: "FR",
    temperatureUnit: "C"

*/

  //State
  const [form, setForm] = useState({
    email: "",
    password: "",
    passwordRepeat: "",
    firstName: "",
    lastName: "",
    companyName: "",
    language: "",
    temperatureUnit: ""
  });
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);
  const [verify, setVerify] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm, setConfirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  //Var
  const TemperatureUnit = [
    {code: "C", name: "Celsius"},
    { code: "F", name: "Fahrenheit"}
  ]
  

  //Email Input
  const onChangeEmail = (e) =>
  {

    let email = e.target.value;

    if (email.length > 320) return; //Check length

    onValidateField("email", email); //Validate field value

    setForm(form => ({
      ...form,
      email
    }));

  };

  //First Name Input
  const onChangeFirstName = (e) =>
  {

    let firstName = e.target.value;

    if (firstName.length > 60) return;  //Check length

    onValidateField("firstName", firstName); //Validate field value

    setForm(form => ({
      ...form,
      firstName
    }));

  };

  //Last Name Input
  const onChangeLastName = (e) =>
  {

    let lastName = e.target.value;

    if (lastName.length > 60) return;  //Check length

    onValidateField("lastName", lastName); //Validate field value

    setForm(form => ({
      ...form,
      lastName
    }));

  };

  //Company name Input
  const onChangeCompanyName= (e) =>
  {

    let companyName = e.target.value;

    if (companyName.length > 100) return; //Check length

    onValidateField("companyName", companyName); //Validate field value

    setForm(form => ({
      ...form,
      companyName
    }));

  };

  //Password Input
  const onChangePassword = (e) =>
  {

    let password = e.target.value;

    onValidateField("password", password); //Validate field value

    setForm(form => ({
      ...form,
      password
    }));

  };

  //Password repeat Input
  const onChangePasswordRepeat = (e) =>
  {

    let passwordRepeat = e.target.value;

    onValidateField("passwordRepeat", passwordRepeat); //Validate field value

    setForm(form => ({
      ...form,
      passwordRepeat
    }));

  };

  //Language input
  const onChangeLanguage = (e) => {

    let language = e.target.value;

    onValidateField("language", language); //Validate field value

    setForm(form => ({
      ...form,
      language
    }));
  };

  //Temperature Unit input
  const onChangeTemperatureUnit = (e) =>
  {

    let temperatureUnit = e.target.value;

    onValidateField("temperatureUnit", temperatureUnit); //Validate field value

    setForm(form => ({
      ...form,
      temperatureUnit
    }));
  };

  //Validate field 
  const onValidateField = (field = "", value = "") =>
  {

    let currentError = { ...error };
    let currentField = "";

    //Validate email
    currentField = "email";
    if (field === "" || field === currentField)
    {
      //If value is sent, otherwrise take from form state
      currentError[currentField] = "";
      const currentValue = field === "" ? form[currentField] : value;

      // Set an error message if the field is empty or falsy
      if (currentValue == "" || !currentValue)
        currentError[currentField] = "This field can't be empty.";
      else if (currentValue.length > 320) //Too many caracters
        currentError[currentField] = "This field has exceeded the character limit.";
      else if (!isValidEmail(currentValue))
        currentError[currentField] = "Email format is invalid.";

    }

    //Validate first name
    currentField = "firstName";
    if (field === "" || field === currentField)
    {
      //If value is sent, otherwrise take from form state
      currentError[currentField] = "";
      const currentValue = field === "" ? form[currentField] : value;

      // Set an error message if the field is empty or falsy
      if (currentValue == "" || !currentValue)
        currentError[currentField] = "This field can't be empty."
      else if (currentValue.length > 60) //Too many caracters
        currentError[currentField] = "This field has exceeded the character limit.";

    }

    //Validate last name
    currentField = "lastName";
    if (field === "" || field === currentField)
    {
      //If value is sent, otherwrise take from form state
      currentError[currentField] = "";
      const currentValue = field === "" ? form[currentField] : value;

      // Set an error message if the field is empty or falsy
      if (currentValue == "" || !currentValue)
        currentError[currentField] = "This field can't be empty."
      else if (currentValue.length > 60) //Too many caracters
        currentError[currentField] = "This field has exceeded the character limit.";

    }

    //Validate company name
    currentField = "companyName";
    if (field === "" || field === currentField)
    {
      //If value is sent, otherwrise take from form state
      currentError[currentField] = "";
      const currentValue = field === "" ? form[currentField] : value;

      // Set an error message if the field is empty or falsy
      if (currentValue == "" || !currentValue)
        currentError[currentField] = "This field can't be empty."
      else if (currentValue.length > 100) //Too many caracters
        currentError[currentField] = "This field has exceeded the character limit.";

    }

    currentField = "password";
    if (field == "password"){

      //If value is sent, otherwrise take from form state
      currentError[currentField] = "";
      const currentValue = field === "" ? form[currentField] : value;

      if (currentValue == "" || !currentValue)
        currentError[currentField] = "This field can't be empty.";
      else if (currentValue.length > 200)//Too many caracters
        currentError[currentField] = "This field has exceeded the character limit.";
      else if (currentValue.length < 8)//Too few caracters
        currentError[currentField] = "Insufficient characters in the field. (min. 8 characters)";

    }

    currentField = "passwordRepeat";
    if (field == "passwordRepeat")
    {

      //If value is sent, otherwrise take from form state
      currentError[currentField] = "";
      const currentValue = field === "" ? form[currentField] : value;

      if (currentValue == "" || !currentValue)
        currentError[currentField] = "This field can't be empty.";
      else if (currentValue.length > 200)//Too many caracters
        currentError[currentField] = "This field has exceeded the character limit.";
      else if (currentValue.length < 8)//Too few caracters
        currentError[currentField] = "Insufficient characters in the field. (min. 8 characters)";

    }
  
    //Validate password
    if (field === "")
    {

      currentError["password"] = "";
      currentError["passwordRepeat"] = "";

      // Set an error message if the field is empty or falsy
      if (!form.password)
        currentError["password"] = "This field can't be empty.";  
      if (!form.passwordRepeat)
        currentError["passwordRepeat"] = "This field can't be empty.";  

      // If passwords aren't empty
      if (form.password && form.passwordRepeat){


        if (form.password.length > 200) //Too many caracters
          currentError["password"] = "This field has exceeded the character limit.";       
        if (form.passwordRepeat.length > 200) //Too many caracters
          currentError["passwordRepeat"] = "This field has exceeded the character limit.";

        if (form.password.length < 8)//Too few caracters
          currentError["password"] = "Insufficient characters in the field. (min. 8 characters)";
        if (form.passwordRepeat.length < 8) //Too few caracters
          currentError["passwordRepeat"] = "Insufficient characters in the field. (min. 8 characters)";

        //If password doesnt match
        if (currentError["password"] == "" && currentError["passwordRepeat"] == "" && form.password != form.passwordRepeat)
          currentError["passwordRepeat"] = "Passwords must match.";
      }
        
        
    }

    
    //Validate Language
    currentField = "language";
    if (field === "" || field === currentField)
    {
      //If value is sent, otherwrise take from form state
      currentError[currentField] = "";
      const currentValue = field === "" ? form[currentField] : value;

      if (currentValue == "" || !currentValue)
        currentError[currentField] = "This field can't be empty.";
    }

    //Validate Temperature Unit
    currentField = "temperatureUnit";
    if (field === "" || field === currentField)
    {
      //If value is sent, otherwrise take from form state
      currentError[currentField] = "";
      const currentValue = field === "" ? form[currentField] : value;

      if (currentValue == "" || !currentValue)
        currentError[currentField] = "This field can't be empty.";
    }



    setError(currentError);

    let valid = true;

    for (let key in currentError)
    {
      if (currentError.hasOwnProperty(key))
      {
        if (currentError[key] !== "")
          valid = false;
      }
    }



    return valid;

  };

  const onClickSubmit = async () =>
  {

    if (!onValidateField())
    {
      setAlert({
        Title: getLabel("App", "Error"),
        Message: getLabel("App", "The form contains errors. Please check and fix the fields highlighted in red."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });
      return;
    }

    try
    {

      setLoading(true);

      let response = await authApi.signupAuth(form);

      if (response.Error)
      {
        setAlert({
          Title: getLabel("App", "Error"),
          Message: getLabel(response.Error.component, response.Error.label) || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
          Confirm: getLabel("App", "Ok"),
          onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
          Display: true
        });

        setLoading(false);

        return;

      }

      setLoading(false);

      setVerify(true);

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      setLoading(false);

    }

  }

  const onClickCancel = () => {

    setConfirm(confirm => ({
      Title: getLabel("App", "Cancel"),
      Message: getLabel(component, "Do you really want to cancel the account creation?"),
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: () => Navigate("/"),
      Display: true
    }));

  }


  return (
    <div className="auth_page_cont">
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <ConfirmModal
        Display={confirm.Display}
        Title={confirm.Title}
        Message={confirm.Message}
        Cancel={confirm.Cancel}
        onCancel={confirm.onCancel}
        Confirm={confirm.Confirm}
        onConfirm={confirm.onConfirm}
      />
      <div className="auth_page_title">
        <img src={logo} alt="logo" style={{ width: "50%" }} />
      </div>
      {verify ? (
        <div className="auth_cont">
          <LoadingComponent
            display={loading}
            label={getLabel("App", "Loading")}
          />
          <div className="auth_cont_title">
            {getLabel(component, "Sign up")}
          </div>
          <div className="auth_cont_body">
            <div className="auth_verify_text">
              {getLabel(component, "Congratulations on successfully creating your account...")}
            </div>
            <div className="auth_verify_text" style={{marginTop: "15px"}}>
              {getLabel(component, "Please check your email and follow the instructions...")}
            </div>
            <div className="auth_verify_text" style={{ marginTop: "15px", fontWeight: "bold", textDecoration: "underline" }}>
              {getLabel(component, "If you can't find the email, kindly check your spam or junk folder.")}
            </div>
            <div className="auth_verify_text" style={{ marginTop: "15px" }}>
              {getLabel(component, "Once your email is verified, you'll...")}
            </div>
          </div>
          <div className="auth_fill_footer" style={{marginTop: "10px"}}>
            <input
              type="button"
              className="page_button auth_cont_cancel_button"
              style={{ backgroundColor: "#424242" }}
              value={getLabel("App", "Home")}
              onClick={() => Navigate("/auth")}
              disabled={loading}
            />
          </div>
        </div>
      ):(
        <div className="auth_cont">
            <LoadingComponent
              display={loading}
              label={getLabel("App", "Loading")}
              isCover={true}
            />
          <div className="auth_cont_title">
            {getLabel(component, "Sign up")}
          </div>
          <div className="auth_cont_body">
            <input
              className={"form-control auth_cont_login_input " + (error["email"] ? "auth_fill_row_input_error" : "")}
                type="search"
              placeholder={getLabel(component, "Email")}
              value={form.email}
              onChange={onChangeEmail}
              disabled={loading}
              autoComplete="new-email"
            />
            {error["email"] &&
              <div className="auth_signup_row_error">
                {getLabel(component, error["email"])}
              </div>
            }
            <input
              className={"form-control auth_cont_login_input " + (error["firstName"] ? "auth_fill_row_input_error" : "")}
              type="text"
              placeholder={getLabel(component, "First name")}
              value={form.firstName}
              onChange={onChangeFirstName}
              disabled={loading}
            />
            {error["firstName"] &&
              <div className="auth_signup_row_error">
                {getLabel(component, error["firstName"])}
              </div>
            }
            <input
              className={"form-control auth_cont_login_input " + (error["lastName"] ? "auth_fill_row_input_error" : "")}
              type="text"
              placeholder={getLabel(component, "Last name")}
              value={form.lastName}
              onChange={onChangeLastName}
              disabled={loading}
            />
            {error["lastName"] &&
              <div className="auth_signup_row_error">
                {getLabel(component, error["lastName"])}
              </div>
            }
            <input
              className={"form-control auth_cont_login_input " + (error["companyName"] ? "auth_fill_row_input_error" : "")}
              type="text"
              placeholder={getLabel(component, "Company name")}
              value={form.companyName}
              onChange={onChangeCompanyName}
              disabled={loading}
            />
            {error["companyName"] &&
              <div className="auth_signup_row_error">
                {getLabel(component, error["companyName"])}
              </div>
            }
            <select
              value={form.language}
              className={"page_select_input " + (error["language"] ? "auth_fill_row_input_error " : "")}
              onChange={onChangeLanguage}
              style={{ width: "90%", textAlign: "center", color: (form.language == "" ? "grey" : "black"), fontWeight: "bold", marginTop: "10px" }}
              disabled={loading}
            >
              <option value="" hidden style={{ textAlign: "center" }}>{getLabel("App", "Language")}</option>
              {Language.map((l, index) => (
                <option key={index} value={l.code} style={{ textAlign: "center", color: "black", fontWeight: "bold" }}>
                  {l.name}
                </option>
              ))}
            </select>
              {error["language"] &&
                <div className="auth_signup_row_error">
                  {getLabel(component, error["language"])}
                </div>
              }
            <select
              value={form.temperatureUnit}
              className={"page_select_input " + (error["temperatureUnit"] ? "auth_fill_row_input_error " : "")}
               onChange={onChangeTemperatureUnit}
               style={{ width: "90%", textAlign: "center", color: (form.temperatureUnit == "" ? "grey" : "black"), fontWeight: "bold", marginTop: "20px" }}
              disabled={loading}
            >
              <option value="" hidden style={{ textAlign: "center" }}>{getLabel("App", "Temperature Unit")}</option>
              {TemperatureUnit.map((t, index) => (
                <option key={index} value={t.code} style={{ textAlign: "center", color: "black", fontWeight: "bold" }}>
                  {t.name}
                </option>
              ))}
            </select>
              {error["temperatureUnit"] &&
                <div className="auth_signup_row_error">
                  {getLabel(component, error["temperatureUnit"])}
                </div>
              }
            <div style={{ width: "100%", height: "20px" }} />
            <input
              className={"form-control auth_cont_login_input " + (error["password"] ? "auth_fill_row_input_error" : "")}
              type="password"
              placeholder={getLabel(component, "Password")}
              value={form.password}
              onChange={onChangePassword}
              disabled={loading}
              autoComplete="password"
            />
            {error["password"] &&
              <div className="auth_signup_row_error">
                {getLabel(component, error["password"])}
              </div>
            }
            <input
              className={"form-control auth_cont_login_input " + (error["passwordRepeat"] ? "auth_fill_row_input_error" : "")}
              type="password"
              placeholder={getLabel(component, "Repeat password")}
              value={form.passwordRepeat}
              onChange={onChangePasswordRepeat}
              disabled={loading}
              autoComplete="repeatpassword"
            />
            {error["passwordRepeat"] &&
              <div className="auth_signup_row_error">
                {getLabel(component, error["passwordRepeat"])}
              </div>
            }
          </div>
          <div className="auth_fill_footer" style={{ marginTop: "10px" }}>
            <input
              type="button"
              className="page_button auth_cont_login_button"
              value={getLabel(component, "Submit")}
              onClick={onClickSubmit}
              disabled={loading}
            />
            <input
              type="button"
              className="page_button auth_cont_cancel_button"
              style={{ backgroundColor: "#424242" }}
              value={getLabel(component, "Cancel")}
              onClick={onClickCancel}
              disabled={loading}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default AuthSignup;